import React, {useEffect, useState} from "react";
import {Backdrop, Box, Grid, IconButton, InputAdornment, MenuItem, Paper, Typography, Link as MuiLink} from "@material-ui/core";
import StyledTextField from "../../../../Crudder/components/CrudDetail/StyledTextField";
import {CompanyResponse} from "../../../../Api/data/company/types";
import {getAllCompanies} from "../../../../Api/data/company/client";
import InputSelect from "../../../../Crudder/components/InputSelect";
import {CurrencyResponse} from "../../../../Api/data/currency/types";
import {getAllCurrencies} from "../../../../Api/data/currency/client";
import InvoiceItemsFormPart from "./InvoiceItemsFormPart";
import {IFormTemplate} from "../../../../Crudder/components/CrudDetail/CrudDetailForm";
import {Autocomplete, Switches, TextField} from "mui-rff";
import useStyles from "./styles";
import InputDate from "../../../../Crudder/components/InputDate";
import Dropzone from "react-dropzone";
import {Field, useForm} from "react-final-form";
import {OnChange} from "react-final-form-listeners";
import {OfferResponse, RealizationPlace} from "../../../../Api/data/offer/types";
import {Alert, SpeedDial, SpeedDialAction, SpeedDialIcon} from "@material-ui/lab";
import {uploadFile} from "../../../../Api/data/file/client";
import clsx from "clsx";
import {Add, Send, Visibility} from "@material-ui/icons";
import InvoicePreview from "./InvoicePreview";
import InvoiceSendMail from "./InvoiceSendMail";
import {normalizeInvoiceStateLabel} from "../../../../Crudder/utils/utils";
import {InvoiceResponse, InvoiceState, PaymentMethod} from "../../../../Api/data/invoice/types";
import {getSystemVariableByCode, getSystemVariableDetails} from "../../../../Api/data/systemVariable/client";
import {getCurrentExchangeRate, getInvoiceEmails} from "../../../../Api/data/invoice/client";
import OfferFileList from "../../OfferModule/components/OfferFileList";
import {SelectMode} from "../../../../Crudder/components/CrudList/CrudList";
import FileDropZone from "../../FileModule/components/FileDropZone";
import InvoiceFileList from "./InvoiceFileList";
import CrudDetailAutoFields from "../../../../Crudder/components/CrudDetail/CrudDetailAutoFields";
import { Link } from "react-router-dom";
import EmailLogList from "../../EmailLogModule/EmailLogList";
import {formatDate} from "../../../../../utils/Date";

interface IProcessingFileProps {
    name: string,
    progress: number,
}

const InvoiceForm: React.FC<IFormTemplate<InvoiceResponse>> = ({ data}) => {
    const classes = useStyles();
    // const formState = useFormState();

    const readonly = false;

    const form = useForm();
    const [ processingFiles, setProcessingFiles ] = useState<{[key: string]: IProcessingFileProps}>({});
    const [ doneFiles, setDoneFiles ] = useState<number[]>([]);
    const [ showPdfPreview, setShowPdfPreview ] = useState<boolean>(false);
    const [ showSendEmail, setShowSendEmail ] = useState<boolean>(false);
    const [ sendEmailAttachments, setSendEmailAttachments ] = useState<number[]>([]);

    const [ filesCounterState, setFilesCounterState ] = useState<number>(1);
    const [ emailsCounterState, setEmailsCounterState ] = useState<number>(1);

    const [ currencies, setCurrencies ] = useState<CurrencyResponse[]>();
    const [ companies, setCompanies ] = useState<CompanyResponse[]>();
    const [ speedDialOpen, setSpeedDialOpen ] = useState<boolean>(false);

    const [ defaultVatRate, setDefaultVatRate ] = useState<number>();

    useEffect(() => {
        getAllCurrencies().then((res) => {
            setCurrencies(res)
        });
        getAllCompanies().then((res) => {
            setCompanies(res)
        });
        getSystemVariableByCode("VAT_RATE").then((res) => {
            setDefaultVatRate(res ? parseFloat(res) : undefined);
        });
    }, []);

    // const {
    //     getRootProps,
    //     getInputProps,
    //     isFocused,
    //     isDragAccept,
    //     isDragReject,
    //     acceptedFiles
    // } = useDropzone( {
    //     noClick: true,
    //     onDrop: (acceptedFiles: File[]) => {
    //
    //         acceptedFiles.forEach(af => {
    //             setProcessingFiles(prevFiles => {
    //                 if (!prevFiles[af.name]) {
    //                     prevFiles[af.name] = {
    //                         name: af.name,
    //                         progress: 0
    //                     }
    //                 }
    //                 return {...prevFiles};
    //             })
    //             const formData = new FormData();
    //             formData.set("data", af.slice(), af.name);
    //             uploadFile(formData, (progress) => {
    //                 setProcessingFiles(prevFiles => {
    //                     prevFiles[af.name].progress = progress;
    //                     return {...prevFiles};
    //                 })
    //             }).then(f => {
    //                 console.log(f)
    //                 setDoneFiles((prevDone) => [...prevDone, f.fileID]);
    //             })
    //                 .catch(f => {
    //                     console.error(f)
    //                 })
    //         });
    //
    //     }
    // });

    useEffect(() => {
        if (currencies && currencies.length > 0) {
            const currency = currencies.find(c => c.currencyID == form.getState().values.currencyID);
            if (currency) {
                form.mutators.setCurrency(currency);
            }
        }
    }, [currencies]);

    useEffect(() => {
        // Initialize paymentMethodIsCash based on paymentMethod from API
        if (data?.paymentMethod !== undefined) {
            const paymentMethodIsCash = (data.paymentMethod as any) === "Cash" || data.paymentMethod === PaymentMethod.Cash;
            form.change('paymentMethodIsCash', paymentMethodIsCash);
        }
    }, [data?.paymentMethod, form]);

    useEffect(() => {
        // Initialize transferredVAT based on transferredVAT from API
        if ((data as any)?.transferredVAT !== undefined) {
            form.change('transferredVAT', (data as any).transferredVAT);
        }
    }, [(data as any)?.transferredVAT, form]);

    const onDrop = (acceptedFiles: File[]) => {

        acceptedFiles.forEach(af => {
            setProcessingFiles(prevFiles => {
                if (!prevFiles[af.name]) {
                    prevFiles[af.name] = {
                        name: af.name,
                        progress: 0
                    }
                }
                return {...prevFiles};
            })
            const formData = new FormData();
            formData.set("data", af.slice(), af.name);
            uploadFile(formData, (progress) => {
                setProcessingFiles(prevFiles => {
                    prevFiles[af.name].progress = progress;
                    return {...prevFiles};
                })
            }).then(f => {
                console.log(f)
                setDoneFiles((prevDone) => [...prevDone, f.fileID]);
            })
                .catch(f => {
                    console.error(f)
                })
        });

    }

    const handleShowPreview = () => {
        setShowPdfPreview(true);
    }

    const handleClosePreview = (filesUpdated?: boolean, filesToSend?: number[]) => {
        setShowPdfPreview(false);
        if (filesUpdated) {
            setFilesCounterState(prevState => prevState + 1);
        }
        if (filesToSend) {
            setSendEmailAttachments(filesToSend);
            setShowSendEmail(true);
        }
    }


    const handleShowSend = () => {
        setShowSendEmail(true);
    }
    const handleCloseSend = (stateUpdated?: boolean) => {
        setShowSendEmail(false);
        setEmailsCounterState(prevState => prevState + 1);
    }

    const updateExchangeRateIfNeeded = async () => {
        const formValues = form.getState().values;
        const currency = formValues.currency;

        // Check if we need to fetch exchange rate
        const shouldFetchRate = currency &&
            currency.alpha3Code !== 'CZK' &&
            !formValues.exchangeRate;

        if (shouldFetchRate) {
            try {
                // Call dedicated exchange rate endpoint
                const exchangeRate = await getCurrentExchangeRate(currency.alpha3Code);

                // Update the form with the new exchange rate
                if (exchangeRate) {
                    form.change('exchangeRate', exchangeRate);
                }
            } catch (error) {
                console.error('Failed to fetch exchange rate:', error);
            }
        }
    }

    return (
        <>
            {showPdfPreview && data && <InvoicePreview invoice={data} onClose={handleClosePreview} />}
            {showSendEmail && data && <InvoiceSendMail invoice={data} onClose={handleCloseSend} selectedAttachments={sendEmailAttachments} />}
            <Dropzone onDrop={onDrop} noClick>
                {({getRootProps, getInputProps, isDragAccept, open: openDropzone}) => (
                    <Box {...getRootProps()}>
                        <Box className={clsx("dropzone", classes.formContainer, {[classes.dropzoneFocused]: isDragAccept})}>
                            <Paper className={classes.section}>
                                <Typography variant={"caption"}>Základní údaje</Typography>
                                <Grid container spacing={4}>
                                    <Grid item xs={3}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <StyledTextField
                                                    className={classes.number}
                                                    name={"number"}
                                                    label={"Číslo"}
                                                    // type={"number"}
                                                    // loading={loading}
                                                    // submitting={submitting}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <StyledTextField
                                                    name={"orderNumber"}
                                                    label={"Číslo objednávky"}
                                                    // loading={loading}
                                                    // submitting={submitting}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <StyledTextField
                                                    name={"offerNumber"}
                                                    label={"Číslo nabídky"}
                                                    // loading={loading}
                                                    // submitting={submitting}
                                                />
                                            </Grid>
                                            {data?.offer && (
                                                <Grid item xs={12}>
                                                    <Box
                                                        style={{
                                                            position: 'relative',
                                                            borderRadius: '4px',
                                                            border: '1px solid rgba(0, 0, 0, 0.23)',
                                                            padding: '10px 14px',
                                                            minHeight: '40px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Typography
                                                            component="label"
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                transform: 'translate(14px, -9px) scale(0.75)',
                                                                transformOrigin: 'top left',
                                                                backgroundColor: 'white',
                                                                padding: '0 5px',
                                                                color: 'rgba(0, 0, 0, 0.54)',
                                                                fontSize: '1rem',
                                                                lineHeight: '1.4375em'
                                                            }}
                                                        >
                                                            Nabídka v systému
                                                        </Typography>
                                                        <MuiLink
                                                            component={Link}
                                                            to={`/offers/offers/${data.offer.offerID}`}
                                                            color="primary"
                                                            underline="hover"
                                                            style={{
                                                                fontSize: '1rem',
                                                                lineHeight: '1.4375em'
                                                            }}
                                                        >
                                                            {data.offer.number || `Nabídka ${data.offer.offerID}`}
                                                        </MuiLink>
                                                    </Box>
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <InputSelect
                                                    field={{name: "invoiceState", title: "Stav"}}
                                                    readonly={readonly}
                                                    className={classes.stateInput}
                                                    itemsGetter={async (search) => {
                                                        return [
                                                            <MenuItem value={InvoiceState.New} key={InvoiceState.New}>{normalizeInvoiceStateLabel(InvoiceState.New)}</MenuItem>,
                                                            <MenuItem value={InvoiceState.Send} key={InvoiceState.Send}>{normalizeInvoiceStateLabel(InvoiceState.Send)}</MenuItem>,
                                                            <MenuItem value={InvoiceState.Paid} key={InvoiceState.Paid}>{normalizeInvoiceStateLabel(InvoiceState.Paid)}</MenuItem>,
                                                        ]
                                                    }}
                                                />
                                            </Grid>
                                            {data?.paidDate && (
                                                <Grid item xs={12}>
                                                    <Typography variant={"caption"}>Uhrazeno {formatDate(data.paidDate)}</Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                {/*<InputSelect*/}
                                                {/*    field={{name: "companyID", title: "Company"}}*/}
                                                {/*    readonly={readonly}*/}
                                                {/*    className={classes.companyInput}*/}
                                                {/*    itemsGetter={async (search) => {*/}
                                                {/*        const companies: CompanyResponse[] = await getAllCompanies();*/}
                                                {/*        return companies.map(c => (*/}
                                                {/*            <MenuItem key={`mi-c-${c.companyID}`} value={c.companyID}>{c.name}</MenuItem>*/}
                                                {/*        ))*/}
                                                {/*    }}*/}
                                                {/*/>*/}
                                                { companies && (
                                                    <>
                                                        <Autocomplete
                                                            options={companies??[]}
                                                            getOptionValue={option => option.companyID}
                                                            getOptionLabel={option => option.name as string}
                                                            filterSelectedOptions
                                                            name={"companyID"}
                                                            label={"Firma"}
                                                            autoHighlight
                                                            className={classes.companyInput}
                                                            textFieldProps={
                                                                {
                                                                    variant: "outlined",
                                                                    // inputProps: {
                                                                    //     readOnly: submitting || loading
                                                                    // },
                                                                    // inputLabelProps: {
                                                                    //     shrink: true,
                                                                    // }
                                                                }
                                                            }
                                                        />
                                                        <OnChange name="companyID">
                                                            {(value, previous) => {
                                                                if (value !== previous) {
                                                                    const selectedCompany = companies.find(c => c.companyID == value);
                                                                    form.mutators.setCompany(selectedCompany);
                                                                }

                                                            }}
                                                        </OnChange>
                                                    </>
                                                )}
                                            </Grid>

                                            {/* Dates section */}
                                            <Grid item xs={3}>
                                                <InputDate
                                                    name="issueDate"
                                                    label="Vystavení"
                                                    placeholder="Vystavení"
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <InputDate
                                                    name="taxableTransactionDate"
                                                    label="Zdanitelné plnění"
                                                    placeholder="Zdanitelné plnění"
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <InputDate
                                                    name="dueDate"
                                                    label="Splatnost"
                                                    placeholder="Splatnost"
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <InputDate
                                                    name="deliveryNoteIssueDate"
                                                    label="Vystavení DL"
                                                    placeholder="Vystavení DL"
                                                />
                                            </Grid>

                                            {/* Currency, Transferred VAT, Exchange Rate */}
                                            <Grid item xs={4}>
                                                { currencies && (
                                                    <>
                                                        <InputSelect
                                                            field={{name: "currencyID", title: "Měna"}}
                                                            readonly={readonly}
                                                            itemsGetter={async (search) => {
                                                                return currencies.map(c => (
                                                                    <MenuItem key={`mi-cur-${c.currencyID}`} value={c.currencyID}>{c.alpha3Code}</MenuItem>
                                                                ))
                                                            }}
                                                        />
                                                        <OnChange name="currencyID">
                                                            {(value, previous) => {
                                                                if (value !== previous) {
                                                                    const selectedCurrency = currencies.find(c => c.currencyID == value);
                                                                    form.mutators.setCurrency(selectedCurrency);

                                                                    // Auto-fetch exchange rate when currency changes
                                                                    setTimeout(() => updateExchangeRateIfNeeded(), 100);
                                                                }
                                                            }}
                                                        </OnChange>
                                                    </>
                                                )}
                                            </Grid>
                                            <Grid item xs={4} style={{display: 'flex', alignItems: 'flex-start', paddingTop: '16px'}}>
                                                <Switches
                                                    name={"transferredVAT"}
                                                    data={{label: "Přenesená DPH", value: false}}
                                                />
                                                <OnChange name="transferredVAT">
                                                    {(value, previous) => {
                                                        if (value !== previous) {
                                                            // Auto-fetch exchange rate when transferred VAT changes
                                                            setTimeout(() => updateExchangeRateIfNeeded(), 100);
                                                        }
                                                    }}
                                                </OnChange>
                                            </Grid>

                                            {/* Exchange Rate field - show for any non-CZK currency */}
                                            <Field name="currency">
                                                {currencyProps => (
                                                    currencyProps.input.value?.alpha3Code !== 'CZK' ? (
                                                        <Grid item xs={4}>
                                                            <StyledTextField
                                                                name="exchangeRate"
                                                                label="Směnný kurz (CZK/měna)"
                                                                type="number"
                                                                inputProps={{ step: "0.0001", readOnly: true }}
                                                                helperText={`Kurz CZK/${currencyProps.input.value?.alpha3Code || 'měna'} (automaticky z CNB)`}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                )}
                                            </Field>

                                            {/* Payment Method */}
                                            <Grid item xs={12} style={{display: 'flex', alignItems: 'flex-start', paddingTop: '16px'}}>
                                                <Switches
                                                    name={"paymentMethodIsCash"}
                                                    data={{label: "Hotově", value: false}}
                                                    helperText="Zaškrtnut = Hotově, Nezaškrtnut = Převodem"
                                                />
                                            </Grid>

                                            {/*<Grid item xs={3}>*/}
                                            {/*    <StyledTextField*/}
                                            {/*        name="currency.exchangeRate"*/}
                                            {/*        label="Exchange Rate"*/}
                                            {/*        disabled={true}*/}
                                            {/*        // value={selectedCurrency?.exchangeRate ?? undefined}*/}
                                            {/*    />*/}
                                            {/*</Grid>*/}


                                            {/*<Grid item xs={3}>*/}

                                            {/*    <Button onClick={handleShowPreview}>Generate</Button>*/}
                                            {/*</Grid>*/}
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper className={classes.section}>
                                <Typography variant={"caption"}>Položky nabídky</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <InvoiceItemsFormPart field={{name: "items", title: "Položky"}} readonly={readonly} form={form} data={data}  />
                                    </Grid>
                                </Grid>

                                <Box className={classes.itemRoot}>
                                    <Box className={classes.itemNumber}>
                                        <IconButton
                                            type="button"
                                            color={"primary"}
                                            onClick={() => form.mutators.push("items", {vatRate: defaultVatRate ?? 21})}
                                            size={"medium"}
                                        >
                                            <Add />
                                        </IconButton>
                                    </Box>

                                    <Grid className={classes.itemForm} container spacing={3}>

                                        <Grid item xs={1}>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <Field name="company.estimatedDelivery">
                                                {props => (
                                                    <StyledTextField
                                                        name="company.estimatedDelivery.total"
                                                        label="Orientační cena dopravy"
                                                        disabled={true}
                                                        className={classes.estimatedDelivery}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">{`${props.input.value.distanceKm??0} km x ${props.input.value.pricePerKm??0} CZK + ${props.input.value.distanceH??0} h x ${props.input.value.pricePerH??0} CZK =`}</InputAdornment>,
                                                            endAdornment: <InputAdornment position="end">CZK</InputAdornment>,
                                                            readOnly: true
                                                        }}
                                                        // value={selectedCurrency?.exchangeRate ?? undefined}
                                                    />
                                                )}
                                            </Field>
                                        </Grid>
                                        <Grid item xs={4} className={classes.paddedItem}>

                                        </Grid>
                                        <Grid item xs={2} className={classes.paddedItem}>
                                            <Typography variant={"h4"}>Celkem</Typography>
                                        </Grid>

                                        <Field name="currency">
                                            {props => (
                                                <>
                                                    <Grid item xs={2}>
                                                        <StyledTextField
                                                            name={"price"}
                                                            label={"Celkem"}
                                                            type={"number"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                            // loading={loading}
                                                            // submitting={submitting}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <StyledTextField
                                                            name={"vat"}
                                                            label={"Celkem DPH"}
                                                            type={"number"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                            // loading={loading}
                                                            // submitting={submitting}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <StyledTextField
                                                            name={"priceVat"}
                                                            label={"Celkem s DPH"}
                                                            type={"number"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                            // loading={loading}
                                                            // submitting={submitting}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Field>

                                        <Field name="transferredVAT">
                                            {props => (
                                                props.input.value && (
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="body2"
                                                            style={{
                                                                fontStyle: 'italic',
                                                                color: '#666',
                                                                textAlign: 'center',
                                                                marginTop: '8px',
                                                                padding: '8px',
                                                                backgroundColor: '#f5f5f5',
                                                                borderRadius: '4px'
                                                            }}
                                                        >
                                                            Faktura je v režimu přenesené daňové povinnosti. Daň odvede zákazník.
                                                        </Typography>
                                                    </Grid>
                                                )
                                            )}
                                        </Field>
                                    </Grid>

                                </Box>

                            </Paper>

                            {/*<Paper className={classes.section}>*/}
                            {/*    <Grid container spacing={3}>*/}


                            {/*        <Grid item xs={4}>*/}
                            {/*            <StyledTextField*/}
                            {/*                name={"formName"}*/}
                            {/*                label={"Form name"}*/}
                            {/*                type={"text"}*/}
                            {/*                loading={loading}*/}
                            {/*                submitting={submitting}*/}
                            {/*            />*/}
                            {/*        </Grid>*/}
                            {/*        <Grid item xs={4}>*/}
                            {/*            <StyledTextField*/}
                            {/*                name={"typeOfRepaor"}*/}
                            {/*                label={"Type of repair"}*/}
                            {/*                type={"text"}*/}
                            {/*                loading={loading}*/}
                            {/*                submitting={submitting}*/}
                            {/*            />*/}
                            {/*        </Grid>*/}
                            {/*        <Grid item xs={3}>*/}
                            {/*            <StyledTextField*/}
                            {/*                name={"commissionNumber"}*/}
                            {/*                label={"Commission Number"}*/}
                            {/*                type={"text"}*/}
                            {/*                loading={loading}*/}
                            {/*                submitting={submitting}*/}
                            {/*            />*/}
                            {/*        </Grid>*/}
                            {/*        <Grid item xs={3}>*/}
                            {/*            <StyledTextField*/}
                            {/*                name={"invoiceNumber"}*/}
                            {/*                label={"Invoice Number"}*/}
                            {/*                type={"text"}*/}
                            {/*                loading={loading}*/}
                            {/*                submitting={submitting}*/}
                            {/*            />*/}
                            {/*        </Grid>*/}
                            {/*        <Grid item xs={3}>*/}
                            {/*            <InputDate*/}
                            {/*                name="dueDate"*/}
                            {/*                label="Due date"*/}
                            {/*                placeholder="Due date"*/}
                            {/*            />*/}
                            {/*        </Grid>*/}
                            {/*        <Grid item xs={3}>*/}
                            {/*            <InputDate*/}
                            {/*                name="payDate"*/}
                            {/*                label="Pay date"*/}
                            {/*                placeholder="Pay date"*/}
                            {/*            />*/}
                            {/*        </Grid>*/}


                            {/*    </Grid>*/}
                            {/*</Paper>*/}
                            <Paper className={classes.section}>
                                <Typography variant={"caption"}>Doplňující údaje</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            name={"note"}
                                            label={"Poznámka"}
                                            placeholder={"Poznámka"}
                                            type={"text"}
                                            fullWidth
                                            rows={4}
                                            // margin="normal"
                                            variant="outlined"
                                            color="primary"
                                            multiline={true}
                                            // InputProps={{
                                            //     readOnly: submitting || loading,
                                            // }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper className={clsx(classes.section, classes.sectionAttachments)}>
                                <Typography variant={"caption"}>Přílohy</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        {
                                            data?.invoiceID ? (
                                                <InvoiceFileList
                                                    key={`files-state-${filesCounterState}`}
                                                    invoiceID={data.invoiceID}
                                                    crudListProps={{
                                                        density: "compact",
                                                        selectMode: SelectMode.NONE,
                                                        disableEdit: true,
                                                    }}
                                                />
                                            ) : (
                                                <Alert severity={"info"} title={"No files"}>Žádné přílohy</Alert>
                                            )
                                        }

                                    </Grid>
                                    <Grid item xs={12}>


                                        <Typography variant={"caption"}>K přidání</Typography>
                                        <Field name={"files"}>
                                            {props => (
                                                <>
                                                    <FileDropZone
                                                        onChange={props.input.onChange}
                                                        value={props.input.value}
                                                        processingFiles={processingFiles}
                                                        doneFiles={doneFiles}
                                                        open={openDropzone}
                                                    />
                                                </>
                                            )}
                                        </Field>

                                    </Grid>
                                </Grid>
                            </Paper>

                            {!!data?.invoiceID && (
                                <Paper className={classes.section}>
                                    <Typography variant={"caption"}>Odeslané e-maily</Typography>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <EmailLogList
                                                key={`emails-state-${emailsCounterState}`}
                                                fetchEmails={() => getInvoiceEmails(data.invoiceID)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            )}

                            {!!data?.invoiceID && (
                                <>
                                    <Backdrop
                                        className={classes.backdrop}
                                        open={speedDialOpen}
                                    />
                                    <SpeedDial
                                        ariaLabel="SpeedDial example"
                                        className={classes.speedDial}
                                        icon={<SpeedDialIcon />}
                                        onClose={() => setSpeedDialOpen(false)}
                                        onOpen={() => setSpeedDialOpen(true)}
                                        open={speedDialOpen}
                                        direction={"up"}
                                    >
                                        <SpeedDialAction
                                            icon={<Send />}
                                            tooltipTitle={"Odeslat"}
                                            onClick={handleShowSend}
                                            tooltipOpen
                                        />
                                        <SpeedDialAction
                                            icon={<Visibility />}
                                            tooltipTitle={"Náhled"}
                                            onClick={handleShowPreview}
                                            tooltipOpen
                                        />
                                    </SpeedDial>
                                </>
                            )}

                        </Box>
                    </Box>
                    )}
            </Dropzone>
        </>
    );
}
export default InvoiceForm;